
import InputDropdown from '@/components/Search/InputDropdown.vue'
import Button from '@/components/UntitledUI/Button.vue'
import Icon from '@/components/UntitledUI/Icon.vue'
import Tippy from '@/components/common/Tippy.vue'
import ClickOutside from 'vue-click-outside'
import SearchHistoryList from '@/components/Search/SearchHistoryList.vue'
import SearchHistoryItem from '@/components/Search/SearchHistoryItem.vue'
import 'tippy.js/dist/tippy.css'
import 'tippy.js/themes/light-border.css'
import { debounce } from 'lodash'

export default {
    name: 'SearchBar',
    directives: {
        ClickOutside
    },
    components: { InputDropdown, Button, Icon, Tippy, SearchHistoryList, SearchHistoryItem },
    props: {
        searchText: {
            type: String,
            default: null
        },
        mainTags: {
            type: Array,
            default: () => []
        },
        mainTag: {
            type: Object,
            default: null
        },
        searchTags: {
            type: Array,
            default: () => []
        },
        haveFilters: {
            type: Boolean,
            default: false
        },
        prefix: {
            type: String,
            default: 'search'
        },
        feature: {
            type: String,
            default: null
        },
        store: {
            type: String,
            default: 'files'
        }
    },
    data () {
        return {
            textModel: this.searchText,
            isFocusing: false,
            prevSearches: [],
            suggestions: [],
            searchOption: this.$route.query.type === 'verbatim' ? 'verbatim' : 'all',
            suggestionLoading: false,
            selectedSuggestion: null,
            getSearchSuggestionsDebounced: null
        }
    },
    computed: {
        searchTypes () {
            return this.mainTags.filter(tag => !tag.locked).map(tag => ({ id: tag.id, value: tag.key }))
        },
        searchType () {
            return this.mainTag ? { id: this.mainTag.id, value: this.mainTag.key } : null
        }
    },
    watch: {
        selectedSuggestion (index) {
            if (index !== null) {
                this.$refs.dropdown.children[index]?.focus()
            }
        },
        textModel (text) {
            this.$emit('change-query', text)
        },
        searchText (text) {
            this.textModel = text
            this.selectedSuggestion = null
            /* if (text && text.length !== 0) {
                this.suggestionLoading = true
                this.getSearchSuggestionsDebounced()
            } */
        },
        searchOption (op) {
            this.$emit('change-type', op)
            this.isFocusing = false
        }
    },
    created () {
        this.getSearchSuggestionsDebounced = debounce(this.getSearchSuggestions, 400)
    },
    methods: {
        search () {
            this.emitSearch(this.textModel ?? '')
        },
        startSearchBy (text) {
            this.textModel = text
            this.emitSearch(text)
        },
        toggleSearchType () {
            this.searchOption = this.searchOption === 'verbatim' ? 'all' : 'verbatim'
        },
        emitSearch (text) {
            this.suggestions = []
            this.$nextTick(() => {
                this.$emit('search', text || '')
                this.$refs.search.blur()
                this.isFocusing = false
            })
        },
        navigateList (e) {
            const selectedIndex = this.selectedSuggestion
            const children = this.textModel.trim().length === 0
                ? this.prevSearches.length : this.suggestions.length
            if (selectedIndex == null && ['ArrowUp', 'ArrowDown'].includes(e.code)) {
                this.selectedSuggestion = e.code === 'ArrowUp' ? children - 1 : 0
                e.preventDefault()
                return
            }
            const mod = (n, m) => ((n % m) + m) % m

            switch (e.code) {
            case 'ArrowUp':
                this.selectedSuggestion = mod(selectedIndex - 1, children)
                e.preventDefault()
                break
            case 'ArrowDown':
                this.selectedSuggestion = mod(selectedIndex + 1, children)
                e.preventDefault()
                break
            default:
                this.$refs.search.focus()
            }
        },
        getSearchSuggestions () {
            /* return
             const query = this.searchText.trim()
            if (!query || query.length === 0) {
                return
            }
            if (!this.suggestionLoading) {
                this.suggestionLoading = true
            }
            const params = {
                query,
                main: this.mainTag ? this.mainTag.type + this.mainTag.prefix : undefined,
                tags: this.searchTags,
                feature: this.feature ?? undefined
            }
            this.$axios.$get('/v1/search-autocomplete', {
                params
            })
                .then((response) => {
                    this.suggestionLoading = false
                    this.suggestions = response
                }) */
        },
        showSearchFilters () {
            this.$emit('toggle-filters')
        },
        onTippyShow () {
            return !this.searchType
        },
        inputFocused () {
            if (this.suggestions.length === 0) {
                this.getSearchSuggestionsDebounced()
            }
        }
    },
    emits: ['search', 'change-query', 'change-main', 'toggle-filters', 'change-type']
}
